<template>
  <div
    class="pc-answer"
    :class="{ 'overflow': dateShow }"
  >
    <!-- 顶部题目信息 -->
    <div class="pc-title">{{ paper_info.subtitle }}</div>
    <div class="pc-text">
      <div class="pc-item">{{ goodsInfo.timu_count }}道精选问题</div>
      <div class="pc-item">{{ goodsInfo.report_page_count }}页专业报告</div>
      <div class="pc-item">98%的好评</div>
      <!-- <div
        class="pc-item"
      >{{ goodsInfo.goods_vr_sale_count }}人测过</div> -->
    </div>
    <!-- 进度条 -->
    <div class="pc-progress-content">
      <div class="pc-progress">
        <van-progress
          :percentage="percentage"
          stroke-width="16px"
          color="#FF5D7D"
          :show-pivot="false"
        />
      </div>
      <div class="pc-num">
        <span class="pc-current-num">{{ currentIndex + 1 }}</span>/
        <span>{{ examPaper.length }}</span>
      </div>
      <div
        class="pc-reset"
        @click="handleReset"
      >重新测试</div>
    </div>
    <!-- 题目区域 -->

    <div
      class="pc-topic-content"
      :class="{ 'animate-next': animate }"
    >
      <div class="pc-topic-title">{{ currentIndex + 1 }}、{{ current.subject }}</div>
      <!-- 文本类型的题目选项 -->
      <div
        class="pc-topic-text"
        v-if="!isImgSubject"
      >
        <img
          v-if="current.subject_image"
          class="pc-topic-img"
          :src="current.subject_image"
        />
        <div
          class="item"
          :class="{ 'active': isActive(index) }"
          v-for="(item, index) in current.option"
          :key="index"
          @click="handleOption(index)"
        >
          <div class="left">{{ optionNames[index] }}</div>
          <div class="right">{{ item.name }}</div>
        </div>
      </div>
      <!-- 图片类型的题目选项 -->
      <div
        class="pc-topic-picture"
        v-if="isImgSubject"
      >
        <img
          class="pc-topic-img"
          :src="current.subject_image"
        />
        <div class="pc-card-content">
          <div
            class="pc-card-item"
            :class="{ 'active': isActive(index) }"
            v-for="(item, index) in current.option"
            :key="index"
            @click="handleOption(index)"
          >
            <img
              class="pc-card-img"
              :src="item.img"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 上一题下一题 -->
    <div class="pc-last-next">
      <div
        class="pc-button"
        v-show="!isLast"
        @click="handleLast"
      >上一题</div>
      <div
        class="pc-button"
        v-show="!isLast"
        @click="handleNext"
      >下一题</div>

      <div
        class="pc-button check-report"
        :class="{ 'disabled': disabled }"
        v-show="isLast"
        @click="handleLookReport"
      >查看报告</div>
    </div>

    <!-- 做题须知 -->
    <div
      class="pc-instructions"
      v-if="goodsInfo.has_goods_notice"
    >
      <div class="item">
        <p>{{ goodsInfo.goods_notice_title }}</p>
        <div v-html="goodsInfo.goods_notice"></div>
      </div>
      <div class="pc-qrcard-content">
        <QrCard
          class="pc-qrcard"
          vertical
          :showTitle="false"
        />
      </div>
    </div>

    <!-- 年龄选择 -->
    <ChooseBirthday
      :paperSet="paperSet"
      v-model:show="dateShow"
      @confirm="handleBirthdayConfirm"
    />
  </div>
</template>

<script>
import { reactive, toRefs,unref, computed, onMounted, onBeforeUnmount } from "vue";
import ChooseBirthday from "@/components/ChooseBirthday";
import { useRouter, useRoute } from "vue-router";
import QrCard from "@/components/QrCard";
import { Notify, Toast, Dialog } from "vant";
import {
  getExamPaper,
  answerSave,
  examPaperSave,
  getDetailAnswer,
} from "@/api/goods";
import { setBirthday } from "@/api/common";
import { checkGoodsOrder } from "@/api/pay";
import { optionNames } from "../letter";

import qs from "qs";
export default {
  name: "Promotional",
  components: {
    ChooseBirthday,
    QrCard,
  },

  setup() {
    const router = useRouter();
    const route = useRoute();

    // 试卷订单ID
    const { paper_order_sn, guid, puid } = route.query;

    const state = reactive({
      optionNames,
      // 评测须知显示隐藏
      questionVisible: false,
      // 当前题目索引
      currentIndex: 0,
      // 已回答的题目
      answerList: [],

      // 试卷列表
      examPaper: [],

      isStop: true,

      // 商品信息
      goodsInfo: {},

      // 生日选择
      dateShow: false,

      // 试卷信息
      paper_info: {},
      //动画显示隐藏
      animate: true,

      paperSet: {},
      paper_tips: {}
    });

    // 当前题目
    const current = computed(() => state.examPaper[state.currentIndex] || {});
    // 当前题目答案
    const currentOptionAnswer = computed(() =>
      state.answerList.find((v) => v.id === current.value.id)
    );
    // 最后一题是否回答完毕
    const disabled = computed(
      () => state.answerList.length < state.examPaper.length
    );
    // 是否已经是最后一题
    const isLast = computed(
      () => state.currentIndex === state.examPaper.length - 1
    );
    // 进度条当前进度
    const percentage = computed(() => {
      if (!state.examPaper.length) return 0;
      const value = ((state.currentIndex + 1) / state.examPaper.length) * 100;
      if (value >= 100) {
        return 100;
      }
      return value;
    });

    // 初始化试卷
    async function init() {
      try {
        const {
          data: { paper_order_detail, goods_info, paper_info, paperSet, paper_tips },
        } = await getExamPaper({ paper_order_sn });
        document
          .querySelector('meta[name="description"]')?.setAttribute("content", paper_info.subtitle);
        state.examPaper = paper_order_detail;
        state.goodsInfo = goods_info;
        state.paper_info = paper_info;
        state.time = paper_info.countdown * 60 * 1000;
        state.paperSet = paperSet;
        state.paper_tips = Object.fromEntries(paper_tips.map(e => [e.paper_detail_no, e.tips]))
      } catch (error) {
        if (puid || guid) {
          router.replace({
            path: "/goods",
            query: {
              puid,
              guid,
            },
          });
        } else {
          router.replace("/");
        }
      }
    }
    // 根据订单号 获取已经答过的答案
    async function getAnswer() {
      const { data } = await getDetailAnswer({ paper_order_sn });
      if (data.length > 0) {
        state.currentIndex = data.length - 1;
        state.answerList = data;

        if (route.path !== "/exam") return;
        state.notify = Notify({
          message: `已经加载${state.answerList.length}道答题记录，点此重新做题`,
          background: "#2196F3",
          duration: 0,
          className: "pc-notify",
          onClick: () => {
            state.answerList = [];
            state.currentIndex = 0;
            state.notify?.close();
          },
        });
      } else {
        if (state.paperSet.needSet == 1 && state.paperSet.setType == 1) {
          // state.dateShow = true;
          goChooseYear()

        }
      }
    }

    // 题目点击
    async function handleOption(index) {
      state.notify?.close();
      if (!state.animate) return;
      // 判断已回答列表中是否有该题目 没有则将答案及试卷id push进去
      if (currentOptionAnswer.value) {
        // 有该条答案 则修改该答案
        const val = state.answerList.find((v) => v.id === current.value.id);
        val.answer = index;
      } else {
        state.answerList.push({
          id: current.value.id,
          answer: index,
        });
      }

      // 判断最后一题是否回答完毕
      if (isLast.value) {
        Notify({
          message: "答题完毕，请点击下方“查看报告”按钮",
          background: "#07c160",
          className: "pc-notify",
        });
      } else {
        handleNext();
      }



      if ((state.currentIndex + 1) % 5 === 0 || isLast.value) {
				// 提交每一题的答案
				await answerSave({
					paper_order_sn,
					answerData: state.answerList,
				});
			}
    }
    // 题目是否已选择
    function isActive(index) {
      return currentOptionAnswer.value?.answer === index;
    }

    // 下一题按钮
    function handleNext() {
      if (!currentOptionAnswer.value) {
        return Toast("请选择您的答案");
      }
      state.notify?.close();
      state.animate = false;

      window.setTimeout(() => {
        state.animate = true;
        state.currentIndex += 1;
        state.paper_tips[state.currentIndex] && Dialog.alert({
          message: state.paper_tips[state.currentIndex],
          theme: 'round-button',
        }).then(() => {
        })
      }, 300);
    }
    // 上一题按钮
    function handleLast() {
      if (state.currentIndex === 0) {
        return Toast("没有上一题了");
      }
      state.notify?.close();
      state.currentIndex += -1;
    }

    // 生日选择确定按钮
    async function handleBirthdayConfirm(age) {
      await setBirthday({
        age: Number(age),
        paper_order_sn,
      });

      if (state.paperSet.setType == 2) {
        handleReport();
      } else {
        state.dateShow = false;
      }
    }

    // 查看报告按钮
    async function handleLookReport() {
      if (disabled.value) return;
      if (state.paperSet.needSet == 1 && state.paperSet.setType == 2) {
        // state.dateShow = true;
        goChooseYear()
      } else {
        handleReport();
      }
    }

    // 查看报告
    async function handleReport() {
      try {
        await examPaperSave({
          paper_order_sn,
          answerData: state.answerList,
        });
        const { data } = await checkGoodsOrder({ paper_order_sn });
        // data为1 已支付状态
        const path = data === 1 ? "/report" : "/pay";

        // 跳转支付引导页
        router.replace({
          path,
          query: {
            paper_order_sn,
            guid,
            puid,
            percent: state.answerList.length,
          },
        });
      } catch (error) {

        Toast("网络异常，请检查网络");
      }
    }
    onBeforeUnmount(() => {
      state.notify?.close();
    });

    // 检查订单状态
    function checkStatus() {
      return new Promise(async (resolve, reject) => {
        const { paper_order_sn, guid, puid, type } = route.query;
        // 重测订单 则不检测 并清除重测参数
        if (type === "reset") {
          const query = {
            ...route.query,
            type: undefined,
          };
          const search = qs.stringify(query);
          window.history.replaceState(
            null,
            null,
            `${window.location.origin + route.path}?${search}`
          );
          resolve();
          return;
        }
        const { data } = await checkGoodsOrder({ paper_order_sn });
        if (data === 1) {
          router.replace({
            path: "/goods",
            query: {
              guid,
              puid,
            },
          });
          reject();
        } else {
          resolve();
        }
      });
    }
    const goChooseYear = async () => {
      await examPaperSave({
        paper_order_sn,
        answerData: state.answerList,
      });
      localStorage.setItem('answerList', JSON.stringify(state.answerList))
      localStorage.setItem('statePaperSet', JSON.stringify(state.paperSet))
      router.push({
        path: '/chooseYear',
        query: route.query
      })
    }
    onMounted(async () => {
      await checkStatus();
      await init();
      getAnswer();

    });

    function handleReset() {
      state.currentIndex = 0;
      state.answerList = [];
    }
    const isImgSubject = computed(() => {
      const isImg = unref(current).option?.find(item => item.img);
      return !!isImg
    })
    return {
      handleNext,
      handleLast,
      handleOption,
      isActive,
      handleLookReport,
      isLast,
      disabled,
      percentage,
      current,
      handleBirthdayConfirm,
      handleReset,
      ...toRefs(state),
      isImgSubject
    };
  },
};
</script>
<style lang="less">
.pc-notify {
  width: 768px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
<style lang="less" scoped>
.animate-next {
  animation-duration: 0.3s;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: next;
}

.overflow {
  height: 100vh;
  overflow: hidden;
}

@keyframes next {
  0% {
    transform: translateX(500px) scale(0.7);
    opacity: 0.7;
  }

  80% {
    transform: translateX(0) scale(0.7);
    opacity: 0.7;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.active {
  background-color: @theme-color;
  color: #fff;
  transition: all 0.3s;
}

.pc-qrcard-content {
  width: 160px;
  display: flex;
  justify-content: center;

  :deep(.pc-qrcard) {
    border: none;
    padding: 0;
    width: 160px;

    .left {
      width: 120px !important;
      height: 120px !important;
    }

    .right {
      justify-content: flex-start;
      font-size: 14px !important;
      padding: 10px 0 0 0;
      line-height: 20px;
      text-align: center;
    }
  }
}

.pc-answer {
  // position: absolute;
  // left: 50%;
  // top: 0;
  // transform: translateX(-50%);
  // width: 100%;
  // height: 100%;
  // overflow-x: hidden;
  .scroll-bar();

  .pc-title {
    text-align: center;
    font-size: 30px;
    color: @theme-color;
    font-weight: bold;
    padding: 10px;
  }

  .pc-text {
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: @gray-color;

    .pc-item {
      padding: 0 5px;
    }
  }

  .pc-progress-content {
    .space-between();
    .align-center();
    padding: 10px 5px;
    height: 60px;

    .pc-progress {
      flex: 1;
    }

    .pc-num {
      font-size: 14px;
      font-weight: bold;
      padding: 0 10px 0 5px;
    }

    .pc-reset {
      color: @theme-color;
      font-size: 14px;
      height: 100%;
      cursor: pointer;
      .align-center();
    }
  }

  .pc-topic-content {
    .pc-topic-title {
      font-size: 22px;
      font-weight: bold;
      padding: 10px 0 20px 0;
    }

    .pc-topic-text {
      .item {
        font-size: 16px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        overflow: hidden;
        margin-bottom: 20px;
        cursor: pointer;
        .align-center;
        position: relative;

        .left {
          font-weight: bold;
          padding: 0 30px;
          background-color: @theme-color;
          color: #fff;
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 70px;
          .align-center;
        }

        .right {
          padding: 13px 0;
          margin-left: 90px;
          line-height: 25px;
        }
      }
    }

    .pc-topic-img {
      width: 340px;
    }

    .pc-topic-picture {
      .pc-card-content {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;

        .pc-card-item {
          width: 170px;
          height: 80px;
          border: 1px solid #e5e5e5;
          margin: 0 10px 10px 0;
          .align-center;
          justify-content: center;
          cursor: pointer;

          .pc-card-img {
            height: 90%;
          }
        }
      }
    }
  }

  .pc-last-next {
    .align-center;
    justify-content: center;
    padding: 20px 0;
    border-bottom: 1px solid #eeeeee;

    .pc-button {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 5px;
      color: #fff;
      background-color: @theme-color;
      margin-right: 10px;
      font-size: 16px;
      cursor: pointer;

      &.check-report {
        width: 160px;
      }
    }
  }

  .pc-instructions {
    padding: 30px 0;
    font-size: 14px;
    line-height: 30px;

    .item {
      flex: 1;
      padding-right: 30px;
    }

    .space-between();
  }
}
</style>